export default function SeoJsonLd() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://goldentwintowers.com';

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Golden Twin Towers Ltd",
    "alternateName": "GTT Ltd",
    "url": siteUrl,
    "logo": `${siteUrl}/logo.png`,
    "description": "Strategic gateway to K-Beauty global distribution across UK, EU & MENA markets, plus premium OEM/ODM manufacturing services through certified Korean partners.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "London",
      "addressCountry": "GB"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "email": "info@goldentwintowers.com"
    },
    "sameAs": [
      "https://linkedin.com/company/goldentwintowers",
      "https://instagram.com/goldentwintowers"
    ]
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Golden Twin Towers Ltd | K-Beauty Distribution UK EU MENA & OEM ODM Manufacturing",
    "description": "Golden Twin Towers Ltd (GTT) is your strategic gateway to K-Beauty global distribution across UK, EU & MENA markets. Premium OEM/ODM manufacturing via certified Korean partners.",
    "url": siteUrl,
    "inLanguage": "en-GB",
    "isPartOf": {
      "@type": "WebSite",
      "name": "Golden Twin Towers Ltd",
      "url": siteUrl
    },
    "about": {
      "@type": "Organization",
      "name": "Golden Twin Towers Ltd"
    },
    "dateModified": "2025-07-10"
  };

  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "K-Beauty Distribution & OEM/ODM Manufacturing",
    "provider": {
      "@type": "Organization",
      "name": "Golden Twin Towers Ltd",
      "url": siteUrl
    },
    "areaServed": [
      { "@type": "Country", "name": "United Kingdom" },
      { "@type": "Country", "name": "Germany" },
      { "@type": "Country", "name": "France" },
      { "@type": "Country", "name": "United Arab Emirates" }
    ],
    "description": "Authorized Korean beauty brand distribution and premium OEM/ODM manufacturing services for UK, EU and MENA markets.",
    "name": "K-Beauty Global Distribution & OEM/ODM Services"
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }}
      />
    </>
  );
}
